import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

const SearchBox = ({ placeholder, query, setQuery }) => {
  const [localQuery, setLocalQuery] = useState(query);

  const handleChange = e => {
    const debounce = (callback, wait) => {
      let timerId;
      return (...args) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
          callback(...args);
        }, wait);
      };
    };

    const debouncedSetQuery = debounce(() => setQuery(e.target.value), 700);
    debouncedSetQuery(localQuery);
    setLocalQuery(e.target.value);
  };

  useEffect(() => {
    if (query) {
      setLocalQuery(query);
    } else {
      setLocalQuery('');
    }
  }, [query]);

  return (
    <div className="advanced-search__search-box">
      <input
        type="search"
        id="site-search"
        className="search-field"
        name="q"
        value={localQuery ?? ''}
        placeholder={placeholder}
        onChange={handleChange}
      />
    </div>
  );
};

SearchBox.propTypes = {
  placeholder: PropTypes.string,
  query: PropTypes.string, 
  setQuery: PropTypes.func
};

export default SearchBox;
